var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 7,
    fill: "#55ACE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3115 20.115C40.3665 20.52 39.2866 20.79 38.2066 20.925C39.2866 20.25 40.2315 19.1701 40.6365 17.9551C39.5565 18.6301 38.4766 19.0351 37.1266 19.3051C36.1816 18.2251 34.6965 17.55 33.2115 17.55C30.2415 17.55 27.8115 19.98 27.8115 22.95C27.8115 23.355 27.8116 23.76 27.9466 24.165C23.4916 23.895 19.4416 21.735 16.7416 18.495C16.3366 19.305 16.0666 20.25 16.0666 21.195C16.0666 23.085 17.0116 24.705 18.4966 25.65C17.5516 25.65 16.7416 25.38 16.0666 24.975C16.0666 27.54 17.9565 29.835 20.3865 30.24C19.9815 30.375 19.4416 30.375 18.9016 30.375C18.4966 30.375 18.2266 30.375 17.8216 30.24C18.4966 32.4 20.5216 34.02 22.9516 34.02C21.0616 35.505 18.7666 36.315 16.2016 36.315C15.7966 36.315 15.3916 36.3151 14.8516 36.1801C17.2816 37.6651 20.1166 38.6101 23.2216 38.6101C33.2116 38.6101 38.6115 30.375 38.6115 23.22V22.545C39.6915 22.14 40.6365 21.195 41.3115 20.115Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.f6edb2012b3d67ca7091941c6da48e66.svg";
export { ForwardRef as ReactComponent };